"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareholderEditFormSchema = exports.ShareholderFormSchema = exports.ShareholderUpdateSchema = exports.ShareholderSchema = exports.IndividualShareholderSchema = exports.ShareholderEditKycSchema = exports.ShareholderIdentitySchema = exports.EVM_ADDRESS_REGEX = exports.ShareholderKycSchema = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const yup = __importStar(require("yup"));
const constants_1 = require("../constants");
const enums_1 = require("../contracts/enums");
const Contact_1 = require("./Contact");
const Trustee_1 = require("./Trustee");
const DistributionProfile_1 = require("./DistributionProfile");
const MyStakeAddress_1 = require("./MyStakeAddress");
const WholesaleVerification_1 = require("./WholesaleVerification");
exports.ShareholderKycSchema = yup.object().shape({
    verificationDate: yup.date().nullable().optional(),
    expiryDate: yup.date().nullable().optional(),
    notes: yup.string().trim().max(2000).optional(),
});
exports.EVM_ADDRESS_REGEX = /^0x[0-9a-fA-F]{40}$/;
const INVALID_ADDRESS_MESSAGE = "Enter a valid address (0x followed by 40 hex characters)";
const evmAddressSchema = yup
    .string()
    .trim()
    .lowercase()
    .matches(exports.EVM_ADDRESS_REGEX, { message: INVALID_ADDRESS_MESSAGE, excludeEmptyString: true })
    .nullable()
    .optional();
/** Investor on-chain addresses. Format only — no uniqueness, checksum or chain lookup. */
exports.ShareholderIdentitySchema = yup.object().shape({
    primaryAddress: evmAddressSchema,
    onchainId: evmAddressSchema,
});
const kycExpiryNotPastTest = (value) => {
    if (!value) {
        return true;
    }
    const expiry = (0, mystake_common_sdk_1.convertDateToUtcAtMidnight)(value);
    const today = (0, mystake_common_sdk_1.convertDateToUtcAtMidnight)(new Date());
    return expiry.getTime() >= today.getTime();
};
/** Profile edit: dates optional; when expiry is provided it must not be in the past (today is valid). */
exports.ShareholderEditKycSchema = exports.ShareholderKycSchema.shape({
    expiryDate: yup.date().nullable().optional().test("kyc-expiry-not-past", constants_1.DATE_NOT_PAST, kycExpiryNotPastTest),
});
exports.IndividualShareholderSchema = yup.object().shape({
    legalEntityName: yup.string(),
    legalEntityAddresses: yup.array().of(yup.object().shape({ ...MyStakeAddress_1.MyStakeAddressSchema })),
    contacts: yup.array().of(yup.object().shape({
        ...Contact_1.ContactSchema,
    })),
});
const beneficiaryABNSchema = yup.lazy((value) => {
    if (value && value.length > 0) {
        return yup
            .string()
            .trim()
            .matches(/^[0-9\s]*$/, "ABN should contain only digits")
            .test("beneficiaryABN", "ABN should be 11 digits.", (beneficiaryABN) => {
            if (beneficiaryABN.replace(/\s/g, "").length === 0)
                return true;
            return beneficiaryABN.replace(/\s/g, "").length > 0 && beneficiaryABN.replace(/\s/g, "").length === 11;
        });
    }
    return yup.string().nullable().notRequired();
});
const tfnSchema = yup.lazy((value) => {
    if (value && value.length > 0) {
        return yup
            .string()
            .trim()
            .matches(/^[0-9\s]*$/, "TFN should contain only digits")
            .test("tfn", "TFN should be 8 or 9 digits.", (tfn) => {
            if (tfn.replace(/\s/g, "").length === 0)
                return true;
            return ((tfn.replace(/\s/g, "").length > 0 && tfn.replace(/\s/g, "").length === 9) ||
                (tfn.replace(/\s/g, "").length > 0 && tfn.replace(/\s/g, "").length === 8));
        });
    }
    return yup.string().nullable().notRequired();
});
const investorTypeSchema = yup
    .string()
    .nullable()
    .oneOf([enums_1.InvestorType.CROWD_SOURCED, enums_1.InvestorType.EMPLOYEE, enums_1.InvestorType.RETAIL, enums_1.InvestorType.SOPHISTICATED, null], "Please select Investor type");
/**
 * A single tax-identifier row. A row with no number MUST carry a reason/note; a row with a number
 * needs no reason. Never blocks an ordinary save when no rows are present.
 */
const taxIdentifierEditSchema = yup
    .object()
    .shape({
    type: yup.string().optional(),
    number: yup.string().trim().optional(),
    reasonNote: yup.string().trim().max(500).optional(),
})
    .test("reason-required-when-no-number", "A reason is required when no identifier number is provided", (row) => {
    if (!row) {
        return true;
    }
    const hasNumber = !!row.number?.trim();
    return hasNumber || !!row.reasonNote?.trim();
});
/** Tax identifiers array with the at-most-one-per-type structural rule. */
const taxIdentifiersEditSchema = yup
    .array()
    .of(taxIdentifierEditSchema)
    .test("at-most-one-per-type", "Only one identifier is allowed per type", (rows) => {
    if (!rows) {
        return true;
    }
    const types = rows.map((row) => row?.type).filter(Boolean);
    return new Set(types).size === types.length;
});
/** Fields shared by the per-owner and entity-level FATCA/CRS blocks. All optional at the form level;
 * mandatory-on-Reportable completeness is enforced server-side so an ordinary save is never blocked. */
const fatcaCrsCommonEditShape = {
    taxResidencyCountries: yup.array().of(yup.string()).optional(),
    mailingAddress: yup
        .object()
        .shape({ ...MyStakeAddress_1.MyStakeAddressSchema })
        .nullable()
        .optional()
        .default(undefined),
    taxIdentifiers: taxIdentifiersEditSchema.optional(),
    fatcaStatus: yup.string().optional(),
    crsStatus: yup.string().optional(),
    notes: yup.string().trim().max(2000).optional(),
};
const ownerFatcaCrsEditSchema = yup
    .object()
    .shape({
    ...fatcaCrsCommonEditShape,
    residentialAddress: yup
        .object()
        .shape({ ...MyStakeAddress_1.MyStakeAddressSchema })
        .nullable()
        .optional()
        .default(undefined),
    dateOfBirth: yup.date().nullable().optional(),
    citizenshipCountries: yup.array().of(yup.string()).optional(),
    birthCity: yup.string().trim().max(120).nullable().optional(),
    countryOfBirth: yup.string().nullable().optional(),
})
    .nullable()
    .optional()
    .default(undefined);
const entityFatcaCrsEditSchema = yup
    .object()
    .shape({
    ...fatcaCrsCommonEditShape,
    countryOfIncorporation: yup.string().optional(),
})
    .nullable()
    .optional()
    .default(undefined);
const primaryContactFatcaCrsEditSchema = yup
    .object()
    .shape({
    ...fatcaCrsCommonEditShape,
    residentialAddress: yup
        .object()
        .shape({ ...MyStakeAddress_1.MyStakeAddressSchema })
        .nullable()
        .optional()
        .default(undefined),
    dateOfBirth: yup.date().nullable().optional(),
    citizenshipCountries: yup.array().of(yup.string()).optional(),
    birthCity: yup.string().trim().max(120).nullable().optional(),
    countryOfBirth: yup.string().nullable().optional(),
    // Names are soft-required: the server's Reportable gate reports them, yup does not block a save.
    firstName: yup.string().trim().max(120).optional(),
    middleName: yup.string().trim().max(120).optional(),
    lastName: yup.string().trim().max(120).optional(),
    contactTypes: yup
        .array()
        .of(yup.string().oneOf(Object.values(mystake_common_sdk_1.ContactType)))
        .optional(),
})
    .nullable()
    .optional()
    .default(undefined);
const ownerContactEditSchema = yup
    .object()
    .shape({
    // Email is mandatory so the owner can be invited to log in; only validated when an owner-contact
    // block is present (the block itself stays optional).
    email: yup.string().trim().email("Enter a valid email").required("Owner contact email is required"),
    phone: yup.string().trim().optional(),
    isPrimary: yup.boolean().optional(),
    userId: yup.string().nullable().optional(),
    invitationSentDate: yup.date().nullable().optional(),
    lastLogin: yup.date().nullable().optional(),
    fatcaCrs: primaryContactFatcaCrsEditSchema,
})
    .nullable()
    .optional()
    .default(undefined);
/**
 * Update-flow owner-contact rules: format-only. Legacy shareholder records may not have an owner
 * contact yet (the section was recently made universally visible), so a save that touches address,
 * TFN or contacts must not be blocked by a missing owner-contact email. The controller separately
 * grandfathers legacy empty blocks and refuses newly-added blocks without an email.
 */
const ownerContactUpdateSchema = yup
    .object()
    .shape({
    email: yup.string().trim().email("Enter a valid email").optional(),
    phone: yup.string().trim().optional(),
    isPrimary: yup.boolean().optional(),
    userId: yup.string().nullable().optional(),
    invitationSentDate: yup.date().nullable().optional(),
    lastLogin: yup.date().nullable().optional(),
    fatcaCrs: primaryContactFatcaCrsEditSchema,
})
    .nullable()
    .optional()
    .default(undefined);
const shareholderOwnerSchema = (ownerContact) => yup.object().shape({
    _id: yup.string(),
    firstName: yup.string().trim(),
    middleName: yup.string().trim(),
    lastName: yup.string().trim(),
    address: yup.object().shape({ ...MyStakeAddress_1.MyStakeAddressSchema }),
    asicCompanyIdentifier: yup.string().trim(),
    companyName: yup.string().trim(),
    tfn: yup.string().nullable(),
    fatcaCrs: ownerFatcaCrsEditSchema,
    ownerContact,
});
exports.ShareholderSchema = yup
    .object()
    .shape({
    beneficialOwner: yup.boolean().nullable(),
    isTrustOrSMSF: yup.boolean().nullable(),
    investorType: investorTypeSchema,
    legalEntityName: yup.string(),
    owners: yup.array().of(shareholderOwnerSchema(ownerContactEditSchema)),
    entityType: yup
        .string()
        // Trust and SMSF are stored entity types a record can be loaded with, so an edit of one has to
        // validate. The form still only offers the three owner shapes.
        .oneOf([mystake_common_sdk_1.OwnerType.JOINT, mystake_common_sdk_1.OwnerType.INDIVIDUAL, mystake_common_sdk_1.OwnerType.COMPANY, mystake_common_sdk_1.EntityType.TRUST, mystake_common_sdk_1.EntityType.SMSF])
        .required("Please select an Owner type"),
    beneficiary: yup.array().of(yup.object().shape({
        name: yup.string().trim().max(255),
        abn: beneficiaryABNSchema,
    })),
    contacts: yup.array().of(yup.object().shape({ ...Contact_1.ContactSchemaV2 })),
    // Trustees travel in the record payload like contacts; the server reconciles them on save.
    trustees: yup.array().of(Trustee_1.TrusteeSchema).optional(),
    firstInvestedDate: yup.date().nullable().default(null),
    kyc: exports.ShareholderKycSchema.nullable().optional(),
    identity: exports.ShareholderIdentitySchema.nullable().optional().default(undefined),
    fatcaCrs: entityFatcaCrsEditSchema,
    // Permitted-set validation is enforced in the controller (returns `invalid_option`); kept as
    // plain optional strings here so an out-of-set value reaches that check rather than a yup error.
    entityClassificationType: yup.string().nullable().optional(),
    entityFiStatus: yup.string().nullable().optional(),
})
    .concat(DistributionProfile_1.DistributionProfileSchema);
/** Saving an existing record: the controller grandfathers a stored empty owner-contact email, so only formats are checked here. */
exports.ShareholderUpdateSchema = exports.ShareholderSchema.shape({
    owners: yup.array().of(shareholderOwnerSchema(ownerContactUpdateSchema)),
});
// Only the redesigned fund form captures a Trust/SMSF by name; elsewhere a company trustee keeps its ACN.
const isTrustEntity = (isTrustOrSMSF, trustSmsfRedesign) => trustSmsfRedesign === true && String(isTrustOrSMSF) === "true";
exports.ShareholderFormSchema = yup.object().shape({
    // Validated in the form, not only on the server, so a trustee's own fields report inline as they
    // are filled. Only a Trust/SMSF holds trustees, so the rows are ignored for every other kind.
    trustees: yup
        .array()
        .of(Trustee_1.TrusteeSchema)
        .when("isTrustOrSMSF", ([isTrustOrSMSF], schema) => String(isTrustOrSMSF) === "true" ? schema : yup.array().optional()),
    isTrustOrSMSF: yup.string().required("Please select trust or SMSF"),
    investorType: investorTypeSchema,
    ownersAddresses: yup.array().of(yup.object().shape({ ...MyStakeAddress_1.MyStakeAddressSchema })),
    owners: yup.array().when("ownerType", ([ownerType]) => ownerType === mystake_common_sdk_1.OwnerType.COMPANY
        ? yup.array().of(yup.object().shape({
            _id: yup.string(),
            firstName: yup.string().trim(),
            middleName: yup.string().trim(),
            lastName: yup.string().trim(),
            tfn: tfnSchema,
            fatcaCrs: ownerFatcaCrsEditSchema,
            ownerContact: ownerContactEditSchema,
        }))
        : yup.array().of(yup.object().shape({
            _id: yup.string(),
            firstName: yup.string().trim().required("Please enter First name"),
            middleName: yup.string().trim(),
            lastName: yup.string().trim().required("Please enter Last name"),
            tfn: tfnSchema,
            fatcaCrs: ownerFatcaCrsEditSchema,
            ownerContact: ownerContactEditSchema,
        }))),
    ownerType: yup
        .string()
        .oneOf([mystake_common_sdk_1.OwnerType.JOINT, mystake_common_sdk_1.OwnerType.INDIVIDUAL, mystake_common_sdk_1.OwnerType.COMPANY])
        .required("Please select an Owner type"),
    beneficiaryName: yup.string().trim().max(255),
    beneficiaryABN: beneficiaryABNSchema,
    contacts: yup.array().of(yup.object().shape({ ...Contact_1.ContactSchemaV2 })),
    acn: yup
        .string()
        .trim()
        .when(["isForeignCompany", "ownerType", "isTrustOrSMSF", "$trustSmsfRedesign"], ([isForeignCompany, ownerType, isTrustOrSMSF, trustSmsfRedesign]) => isForeignCompany || ownerType !== mystake_common_sdk_1.OwnerType.COMPANY || isTrustEntity(isTrustOrSMSF, trustSmsfRedesign)
        ? yup.string()
        : yup
            .string()
            .matches(/^[0-9\s]*$/, "ACN should contain only digits")
            .test("acn", "ACN/ARBN should be 9 digits.", (acn) => acn && acn.replace(/\s/g, "").length > 0 && acn.replace(/\s/g, "").length === 9)),
    companyName: yup
        .string()
        .trim()
        .when(["isTrustOrSMSF", "$trustSmsfRedesign"], ([isTrustOrSMSF, trustSmsfRedesign]) => isTrustEntity(isTrustOrSMSF, trustSmsfRedesign)
        ? yup.string().trim().required("Please enter the trust or SMSF name")
        : yup.string().trim()),
    isForeignCompany: yup.boolean(),
    companyTfn: tfnSchema,
    fatcaCrs: entityFatcaCrsEditSchema,
    // Permitted-set validation is enforced server-side (returns `invalid_option`); optional strings here.
    entityClassificationType: yup.string().optional(),
    entityFiStatus: yup.string().optional(),
});
exports.ShareholderEditFormSchema = yup.object().shape({
    // Same rules the server applies on save: a row it would refuse is reported inline instead.
    trustees: yup.array().of(Trustee_1.TrusteeSchema).optional(),
    investorType: yup
        .string()
        .nullable()
        .oneOf([enums_1.InvestorType.CROWD_SOURCED, enums_1.InvestorType.EMPLOYEE, enums_1.InvestorType.RETAIL, enums_1.InvestorType.SOPHISTICATED, null])
        .when(["$isInvestor"], ([isInvestor]) => isInvestor ? yup.string().nullable() : yup.string().nullable().required("Please select Investor type")),
    ownersAddresses: yup.array().of(yup.object().shape({ ...MyStakeAddress_1.MyStakeAddressSchema })),
    owners: yup.array().of(yup.object().shape({
        _id: yup.string(),
        tfn: tfnSchema,
        fatcaCrs: ownerFatcaCrsEditSchema,
        ownerContact: ownerContactUpdateSchema,
    })),
    beneficiaryName: yup.string().trim().max(255),
    beneficiaryABN: beneficiaryABNSchema,
    contacts: yup.array().of(yup.object().shape({
        ...Contact_1.ContactSchemaV2,
        kyc: exports.ShareholderEditKycSchema.nullable().optional(),
    })),
    kyc: yup.lazy((_value, options) => {
        const isInvestor = options.context?.isInvestor;
        return isInvestor ? exports.ShareholderKycSchema.nullable().optional() : exports.ShareholderEditKycSchema.nullable().optional();
    }),
    identity: exports.ShareholderIdentitySchema.nullable().optional().default(undefined),
    wholesaleVerification: WholesaleVerification_1.WholesaleVerificationSchema.nullable().optional().default(undefined),
    fatcaCrs: entityFatcaCrsEditSchema,
    // Permitted-set validation is enforced server-side (returns `invalid_option`); kept as optional
    // strings here so an out-of-set value reaches that check rather than a yup error.
    entityClassificationType: yup.string().optional(),
    entityFiStatus: yup.string().optional(),
});
//# sourceMappingURL=IndividualShareholder.js.map